module.exports = __webpack_public_path__ + "static/img/solutionPic8.7ec13ba.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionPic8.png
// module id = Uwgq
// module chunks = 1